import React from "react";
import BasePaper from "components/Base/BasePaper";
import EventLogForm from "../EventLogging/EventLogForm";

interface Props {
  notes: string;
  setNotes: (v: string) => void;
  onSubmit: () => void;
}

const EventLogFormSection: React.FC<Props> = ({
  notes,
  setNotes,
  onSubmit,
}) => {
  return (
    <BasePaper>
      <EventLogForm
        notes={notes}
        onChange={{ setNotes }}
        onSubmit={(e: React.FormEvent) => {
          e.preventDefault();
          onSubmit();
        }}
      />
    </BasePaper>
  );
};

export default EventLogFormSection;
